// MultiStepForm.js
import React, { useState } from "react";
import { Step } from "semantic-ui-react";
import { initialValuesZero } from "./StepZero.form";
import { initialValuesOne } from "./StepOne.form";
import { initialValuesTwo } from "./StepTwo.form";
import { initialValuesThree } from "./StepThree.form";
import { initialValuesFour } from "./StepFour.form";
import { initialValuesFive } from "./StepFive.form";
import { initialValuesSix } from "./StepSix.form";
import { StepZero } from "./StepZero";
import { StepOne } from "./StepOne";
import { StepTwo } from "./StepTwo";
import { StepThree } from "./StepThree";
import { StepFour } from "./StepFour";
import { StepFive } from "./StepFive";
import { StepSix } from "./StepSix";
import "./MultiStepForm.scss";

export function MultiStepForm(props) {
  const { isUpdateMode, scene, onReload, onClose } = props;

  const mergedInitialValues = {
    ...initialValuesZero(scene),
    ...initialValuesOne(scene),
    ...initialValuesTwo(scene),
    ...initialValuesThree(scene),
    ...initialValuesFour(scene),
    ...initialValuesFive(scene),
    ...initialValuesSix(scene),
  };

  const [formData, setFormData] = useState(mergedInitialValues);
  const [step, setStep] = useState(1);

  const nextStep = () => setStep((prevStep) => prevStep + 1);
  const prevStep = () => setStep((prevStep) => prevStep - 1);

  const updateFormData = (newData) => {
    setFormData((prevData) => ({
      ...prevData,
      ...newData,
    }));
  };

  return (
    <div>
      {/* Step indicators */}
      <div className="step-group-container">
        <Step.Group ordered>
          <Step active={step === 1} completed={step > 1}>
            <Step.Content>
              <Step.Title>Paso1: ID Interno</Step.Title>
            </Step.Content>
          </Step>
          <Step active={step === 2} completed={step > 2}>
            <Step.Content>
              <Step.Title>Paso2: Portada</Step.Title>
            </Step.Content>
          </Step>
          <Step active={step === 3} completed={step > 3}>
            <Step.Content>
              <Step.Title>Paso3: Orientación</Step.Title>
            </Step.Content>
          </Step>
          <Step active={step === 4} completed={step > 4}>
            <Step.Content>
              <Step.Title>Paso4: Contexto temático</Step.Title>
            </Step.Content>
          </Step>
          <Step active={step === 5} completed={step > 5}>
            <Step.Content>
              <Step.Title>Paso5: Sugerencias de uso</Step.Title>
            </Step.Content>
          </Step>
          <Step active={step === 6} completed={step > 6}>
            <Step.Content>
              <Step.Title>Paso6: Competencias clave</Step.Title>
            </Step.Content>
          </Step>
          <Step active={step === 7} completed={step > 7}>
            <Step.Content>
              <Step.Title>Paso 7: Material extra</Step.Title>
            </Step.Content>
          </Step>
          {/* Add more steps as needed */}
        </Step.Group>
      </div>

      {/* Conditional rendering of steps */}
      {step === 1 && (
        <StepZero
          formData={formData}
          updateFormData={updateFormData}
          nextStep={nextStep}
          scene={scene}
          isUpdateMode={isUpdateMode}
        />
      )}
      {step === 2 && (
        <StepOne
          formData={formData}
          updateFormData={updateFormData}
          nextStep={nextStep}
          prevStep={prevStep}
          scene={scene}
          isUpdateMode={isUpdateMode}
        />
      )}
      {step === 3 && (
        <StepTwo
          formData={formData}
          updateFormData={updateFormData}
          nextStep={nextStep}
          prevStep={prevStep}
          scene={scene}
          isUpdateMode={isUpdateMode}
        />
      )}
      {step === 4 && (
        <StepThree
          formData={formData}
          updateFormData={updateFormData}
          nextStep={nextStep}
          prevStep={prevStep}
          scene={scene}
          isUpdateMode={isUpdateMode}
        />
      )}
      {step === 5 && (
        <StepFour
          formData={formData}
          updateFormData={updateFormData}
          nextStep={nextStep}
          prevStep={prevStep}
          scene={scene}
          isUpdateMode={isUpdateMode}
        />
      )}
      {step === 6 && (
        <StepFive
          formData={formData}
          updateFormData={updateFormData}
          nextStep={nextStep}
          prevStep={prevStep}
          scene={scene}
          isUpdateMode={isUpdateMode}
        />
      )}
      {step === 7 && (
        <StepSix
          formData={formData}
          updateFormData={updateFormData}
          nextStep={nextStep}
          prevStep={prevStep}
          scene={scene}
          isUpdateMode={isUpdateMode}
          onReload={onReload}
          onClose={onClose}
        />
      )}
    </div>
  );
}
